import React from 'react';
import { Routes, Route } from 'react-router-dom';
//import NavigationBar from './generalcompoments/NavigationBar';
import Header from './generalcompoments/header';
//import About from './generalcompoments/About';
import ChatRoom from './generalcompoments/ChatRoom';

function App() {
  return (
    <>
      <Routes>
        {/* Αρχική σελίδα */}
        <Route
          path="/"
          element={
            <>
              <Header />
            </>
          }
        />

        {/* Chat Room */}
        <Route path="/chatroom" element={<ChatRoom />} />

      </Routes>

      {/* Navigation bar σε όλες τις σελίδες */}
    </>
  );
}

export default App;
